<div>
  <div id="multi-scene-cloud" style="width: 100%; height: 540px;"></div>
  <ng-container *ngIf="message">{{message}}</ng-container>
</div>
